import { ArrowUpRight } from "lucide-react";
import { imgUrl } from "@/lib/api";
import { useSite } from "@/lib/SiteContext";
import { ChapterHeading, Em, Reveal } from "./primitives";

export default function Categories({ content, onSelect }) {
  const { categories } = useSite();
  const c = content || {};

  return (
    <section id="categories" className="py-24 md:py-32">
      <div className="mx-auto max-w-7xl px-6 md:px-12">
        <ChapterHeading
          number={(c.kicker || "01 — Categories").split("—")[0].trim()}
          kicker={(c.kicker || "01 — Categories").split("—")[1]?.trim() || "Categories"}
          title={<Em text={c.title || "Shop by *Category*"} />}
          blurb={c.blurb || "Eight little worlds of gifting — each one curated, wrapped and ready to make someone's day."}
        />
        <div className="grid grid-cols-2 gap-6 md:gap-10 lg:grid-cols-4">
          {categories.map((cat, i) => (
            <Reveal key={cat.slug || cat.id} delay={(i % 4) * 0.08}>
              <button
                data-testid={`category-card-${cat.slug || cat.id}`}
                onClick={() => onSelect(cat.slug || cat.id)}
                className="group block w-full text-left"
                aria-label={`Browse ${cat.name}`}
              >
                <div className="overflow-hidden rounded-b-2xl rounded-t-[999px] border border-line bg-white transition-shadow duration-500 group-hover:shadow-xl group-hover:shadow-rose/10">
                  <img
                    src={imgUrl(cat.image)}
                    alt={cat.name}
                    loading="lazy"
                    className="aspect-[3/4] w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                  />
                </div>
                <div className="mt-5 flex items-start justify-between gap-2">
                  <div>
                    <h3 className="font-serif text-xl font-medium text-ink transition-colors duration-300 group-hover:text-rose md:text-2xl">
                      {cat.name}
                    </h3>
                    <p className="mt-1 text-xs text-[#5C5C5C] md:text-sm">
                      {cat.tagline}
                    </p>
                  </div>
                  <ArrowUpRight
                    size={20}
                    className="mt-1 shrink-0 text-rose transition-transform duration-300 group-hover:-translate-y-1 group-hover:translate-x-1"
                  />
                </div>
              </button>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
